/* used within articles, not side bar, these do not have a border/shadow around them and do not link to the product
** TO IMPLEMENT:
**[alias]: the product alias
**[image]: the last number in the image path
**p: the product's name
**figcaption: the product's name

<article-product-card alias="152528" image="542061">
	<figcaption>Ultra Plush Blanket</figcaption>
</article-product-card> 
*/

import { productImagePath } from "../../../common/localized.js";

class ArticleProductCard extends HTMLElement {
	constructor() {
        super();
        
		this.tracking = document.getElementById("trackingID")?.value;
        this.prodName = this.querySelector("figcaption").textContent;
	}
	
	get alias(){
		return this.getAttribute("alias");
	}
	
	set alias(value){
		this.setAttribute("alias", value);
	}
	
	get image(){
		return this.getAttribute("image");
	}
	
	set image(value){
		this.setAttribute("image", value);
	}
	
	connectedCallback() {		
		const style = document.createElement("style");
		style.textContent = `
			:host > div { 
				margin-bottom: 0;
			}
			img	{ max-width: 100%; height: auto; display: block; 
				margin: 0.625rem 0.625rem 1.25rem 0.625rem; }
			
			figure {	text-align: center; margin: 1.5rem 0;}
			figcaption 	{ text-align: center; margin-top: 0.625rem; }
			
			link-element { display: block; }
		`;
		
		//todo should image be webp?
		const articleProductCard = document.createElement("div");
		const html = `
			<link-element color="darkestGray" link="/product/${this.alias}${this.tracking}" padding="10">
			<figure>
				<img width="250" height="250" src="${productImagePath}/250/${this.image}.jpg" alt="${this.prodName}">
				<figcaption>${this.prodName}</figcaption>
			</figure>
			</link-element>
		`;

		articleProductCard.innerHTML = html;
		
		this._shadowRoot = this.attachShadow({ mode: "open" });
		this._shadowRoot.appendChild(style);
        this._shadowRoot.appendChild(articleProductCard);
	}
	
	attributeChangedCallback(attrName, oldValue, newValue) {
		if (newValue !== oldValue) {
			switch (attrName) {
				case 'alias':
				case 'image':
					this[attrName] = this.getAttribute(attrName);
					break;
			}
		}
	}
}

customElements.define('article-product-card', ArticleProductCard);